export default "__VITE_ASSET__BTV6JIXO__"